<template>
  <font-awesome-icon
    size="lg"
    :class="[color ? color + '--text' : null, spin ? 'fa-spin' : null, iconOnly ? 'mr-4' : null]"
    :icon="'far ' + icon"
  />
</template>

<script>
// This component is registered globally in "plugins/vuetify.js"
// Using Font Awesome free SVG icons
export default {
  props: {
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
      required: true,
    },
    spin: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
